import { H1, H4 } from '@zooplus/ui-components';

import styles from './Step.module.scss';
import { Trans } from 'react-i18next';
import { useTranslation } from '../../../hooks/use-translations';
import { AutoshipLogo } from '../../common/autoship-logo/AutoshipLogo';
import { Cart } from '@zooplus/icons';
import React from 'react';

export type CardProps = {
  image?: any;
  number: string;
};

export const Step = (props: CardProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.stepWrapper}>
      <div className={styles.numberWrapper}>
        <H1 className={styles.number}>{props.number}</H1>
      </div>
      <div className={styles.textWrapper}>
        <H4 className={styles.text}>
          <Trans
            i18nKey={`hiw.text-${props.number}`}
            components={{
              logo: <AutoshipLogo logoSize={'medium'} />,
              cart: <Cart className={styles.cartIcon} />,
            }}
            t={t}
          />
        </H4>
      </div>
      <div className={styles.image}>{props.image && <props.image />}</div>
    </div>
  );
};
